import type { IconData } from '@stacksjs/iconify-core'

export const webcamVideo: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M7.471 38.248c-2.31-.354-3.974-2.23-4.147-4.56C3.157 31.448 3 28.218 3 24s.157-7.447.324-9.688c.173-2.33 1.837-4.206 4.147-4.56C9.918 9.376 13.493 9 18 9s8.082.376 10.529.752c2.31.354 3.974 2.23 4.147 4.56c.09 1.2.176 2.684.237 4.45c2.066-1.397 4.97-3.124 8.21-4.343c1.574-.592 3.205.434 3.417 2.103c.233 1.83.46 4.404.46 7.478s-.227 5.648-.46 7.478c-.212 1.669-1.843 2.695-3.417 2.103c-3.24-1.219-6.144-2.946-8.21-4.343c-.06 1.767-.147 3.25-.237 4.45c-.173 2.33-1.837 4.206-4.147 4.56C26.082 38.624 22.507 39 18 39s-8.082-.376-10.529-.752\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default webcamVideo
